import { useTranslation } from 'react-i18next';
import { DoubleArrowLeftIcon, DoubleArrowRightIcon } from '@src/shared/ui/icons';
import { Button } from '@src/shared/ui/Button';
import { DelayedTooltip } from '@src/shared/ui/Tooltip';
import { useSidebar } from '@src/app/layout';

function SidebarToggleButton() {
  const { t } = useTranslation();
  const sidebar = useSidebar();
  const label = sidebar?.isCollapsed ? t('layout.sidebar.expand', "Expand sidebar")
    : t('layout.sidebar.collapse', "Collapse sidebar");

    if (!sidebar) {
    return null;
  }

  return (
    <DelayedTooltip title={label}>
      <Button
        onClick={sidebar.toggle}
        fullWidth
        variant="outlined"
        color="secondary"
        sx={{ minWidth: 0, pt: 1, pb: 1 }}
      >
        {sidebar.isCollapsed ? <DoubleArrowRightIcon color="inherit" fontSize="small" /> : <DoubleArrowLeftIcon color="inherit" fontSize="small" />}
      </Button>
    </DelayedTooltip>
  );
}

SidebarToggleButton.displayName = 'SidebarToggleButton';
export default SidebarToggleButton;
